import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from './form/Checkbox'
import Tooltip from '#components/m/Tooltip'
import Text from './Text'
import Userinfo from '#components/m/Userinfo'

export default function CheckableTask({task: {done, kommentar, text}, onChangeHandle}) {
  const renderCommentTooltip = () => (
    <Tooltip
      trigger={<div className="task__comment task__comment--active" />}
      modifier="dark"
      placement="bottom"
      triggerAction="hover"
    >
      <Userinfo userId={kommentar.authorId} />
      <Text text={`„${kommentar.text}“`} />
    </Tooltip>
  )

  const canCheck = !kommentar
  return (
    <div className={done ? 'task task--done' : 'task'}>
      <Checkbox
        modifier="disabled"
        disabledState={!canCheck}
        checked={done}
        onChangeHandle={onChangeHandle}
        labelText={text}
      />
      {kommentar && renderCommentTooltip()}
    </div>
  )
}

CheckableTask.propTypes = {
  task: PropTypes.shape({
    text: PropTypes.string,
    done: PropTypes.bool,
    kommentar: PropTypes.object,
  }).isRequired,
  onChangeHandle: PropTypes.any,
}
